import { takeLatest } from 'redux-saga/effects';
import fetchListOfTransactionWorker from './transactionWorkerSaga';
import { FETCH_TRANSACTIONS_LIST_REQUEST } from '../../redux/modules/transaction/transaction-actions';

export default function* fetchListOfTransactionWatcher() {
    yield takeLatest(FETCH_TRANSACTIONS_LIST_REQUEST, fetchListOfTransactionWorker);
}
